import { UseFormSetValue } from 'react-hook-form';
import { EditableQuestion } from '../../../../../../../types';
import { useEffect } from 'react';

export const useFollowUpFieldsResetter = (isFollowUpQuestion: boolean, setValue: UseFormSetValue<EditableQuestion>) => {
  useEffect(() => {
    const clearFollowUpOnlyFields = () => {
      setValue('parent_question_id', null);
      setValue('answer_id', null);
    };

    if (!isFollowUpQuestion) {
      clearFollowUpOnlyFields();
    }
  }, [isFollowUpQuestion, setValue]);
};
